import React, { useContext, useState } from 'react';
import { StateContext } from '../../StateContext';
import {
    Modal,
    Button,
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import { boxStyle } from '../Projects/styles';
import { connectMechanicCall } from '../../Services/APICalls/apicalls';
import { IContextData } from '../../../App';
import { useLanguage } from '../../Services/LanguageContext';

interface PProps {
    id: number;
}

const ConnectProject = (props: PProps) => {
    const [open, setOpen] = useState(false);
    const { t } = useLanguage();

    const { loginData, setLoginData } = useContext<IContextData>(StateContext);

    const [selectedProjectId, setSelectedProjectId] = useState(loginData.projects[0]?.id ?? 0);
    const [projectTypeId, setProjectTypeId] = useState<number | ''>('');

    const selectedProject = loginData.projects.find((p) => p.id === selectedProjectId);
    const projectTypes = selectedProject?.types ?? [];

    const handleProjectChange = (x) => {
        setSelectedProjectId(parseInt(x.target.value));
        setProjectTypeId('');
    };

    const connectMechanicHandler = () => {
        connectMechanicCall(selectedProjectId, props.id, setLoginData, t, projectTypeId === '' ? null : projectTypeId);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button
                variant='outlined'
                color='success'
                onClick={() => setOpen(true)}
            >
                {t('connectProject')}
            </Button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle as any}>
                    <form
                        onSubmit={connectMechanicHandler}
                        action='#'
                        className='flex flex-col items-center gap-3'
                        style={{ width: '100%' }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id='project-select-label'>
                                {t('project')}
                            </InputLabel>
                            <Select
                                label={t('project')}
                                labelId='project-select-label'
                                id='project-select'
                                value={selectedProjectId}
                                onChange={handleProjectChange}
                            >
                                {loginData.projects.map((p) => (
                                    <MenuItem key={p.id} value={p.id}>
                                        {p.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {projectTypes.length > 0 && (
                            <FormControl fullWidth>
                                <InputLabel id='project-type-select-label'>
                                    {t('workType')}
                                </InputLabel>
                                <Select
                                    label={t('workType')}
                                    labelId='project-type-select-label'
                                    id='project-type-select'
                                    value={projectTypeId}
                                    onChange={(x) => setProjectTypeId(x.target.value as number | '')}
                                >
                                    <MenuItem value=''>{t('noType')}</MenuItem>
                                    {projectTypes.map((pt) => (
                                        <MenuItem key={pt.id} value={pt.id}>
                                            {pt.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                        <button
                            style={{ width: '100%' }}
                            onClick={connectMechanicHandler}
                        >
                            {t('link')}
                        </button>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default ConnectProject;
